module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Regular.woff2?v=baec4e336ad48453f2185b2a068c6c71";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Regular.woff2
// module id = 672
// module chunks = 0